import React, { useEffect, useState } from 'react';
import { Card, CardBody, Badge, Table } from 'reactstrap';
import FalconCardHeader from '../common/FalconCardHeader';
import Heading from '../common/Heading';
import Loader from '../common/Loader';
// services
import BZAPIService from '../../services/BZAPIService';
//libs
// constants

const Profile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [groups, setGroups] = useState([]);
  const [user, setUser] = useState({});

  useEffect(() => {
    async function onLoad() {
      try {
        setIsLoading(true);
        const myUserRolesPromise = BZAPIService.getMyUserRoles();
        const myUserGroupsPromise = BZAPIService.getMyUserGroups();
        const myUserPromise = BZAPIService.getMyUser();
        const [myUserRoles, myUserGroups, myUser] = await Promise.all([
          myUserRolesPromise,
          myUserGroupsPromise,
          myUserPromise
        ]);
        setRoles(myUserRoles);
        setGroups(myUserGroups);
        setUser(myUser);
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
      }
    }
    onLoad();
  }, []);
  const { email = '(Email address not found)' } = user;
  if (isLoading) return <Loader />;
  return (
    <>
      <Heading title={`Profile: ${email}`} subtitle="View your user profile" className="mb-4 mt-3" icon="user" />
      <Card>
        <FalconCardHeader title="RBAC Groups" />
        <CardBody className="fs--1">
          <div />
          <Table bordered striped style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Group</th>
              </tr>
            </thead>
            <tbody>
              {groups?.length ? (
                groups.map(group => {
                  // Email
                  return (
                    <tr key={group.id} className="font-weight-bold" data-testid={'group-row'}>
                      <td>
                        <div className="py-2">{group.name}</div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr className="font-weight-bold">
                  <td>You have no groups yet</td>
                </tr>
              )}

              <tr />
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <Card className="mt-4">
        <FalconCardHeader title="RBAC User Roles" />
        <CardBody className="fs--1">
          <div />
          <Table bordered striped style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Role</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {roles?.length ? (
                roles.map(role => {
                  // Email
                  return (
                    <tr key={role.id} className="font-weight-bold" data-testid={'role-row'}>
                      <td>
                        <div className="py-2">
                          {role.name}
                          {'  '} {!!role.isDefault && <Badge color="secondary">Default</Badge>}
                        </div>
                      </td>
                      <td>
                        <div className="py-2" data-testid={'role-created-date'}>
                          {role.createdAt}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr className="font-weight-bold">
                  <td>You have no roles yet</td>
                  <td />
                </tr>
              )}

              <tr />
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default Profile;
